export default "__VITE_ASSET__f19daa80__"